import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BsBoxArrowUpRight } from 'react-icons/bs';
import ActiveCallComponent from './ActiveCallComponent';

const ActiveCallModal = ({ show, onClose = () => {}, activeCallId }) => {
    if (!show) return null;

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size="xl"
            backdrop="static"
            scrollable
            dialogClassName="active-call-modal-dialog"
        >
            <Modal.Header closeButton className="py-1">
                <Modal.Title className="d-flex align-items-center gap-2">
                    <strong>Active Call Monitor</strong>
                    {activeCallId && (
                        <a
                            href={`/calls/${activeCallId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Open in new tab"
                            className="text-decoration-none ml-2"
                            onClick={(event) => event.stopPropagation()}
                        >
                            <BsBoxArrowUpRight size={14} />
                        </a>
                    )}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <ActiveCallComponent callId={activeCallId} />
            </Modal.Body>

            <Modal.Footer closeButton className="py-1">
                <Button variant="secondary" onClick={onClose} className="ml-3 py-1">
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ActiveCallModal;
